<template>
    <div>
        <List title="View Servers" @read="load()">
            <ServerCard
                v-for="server in servers"
                :key="server._id"
                :id="server._id"
            />
        </List>
    </div>
</template>

<script>
    import { mapState } from 'vuex'

    import List from '@/components/general/list'
    import ServerCard from './card'

    export default {
        methods: {
            load() {
                return this.$store.dispatch('admin/servers/load')
            }
        },
        computed: mapState({
            servers: state => state.admin.servers.servers
        }),
        components: {
            ServerCard,
            List
        }
    }
</script>